import * as Yup from "yup";
export const step1ValidationSchema = (t = {}, addressRequiredFlag = false, idNumberFlag = true, descriptionRequiredFlag = false) => Yup.object().shape({    phone: Yup.string()
    .matches(
        /^(?:\+?[1-9]\d{1,14}|\d{1,15})$/, 
        t.invalidPhone
    )
    .required(t.phoneRequired),

    name: Yup.string()
    .min(3, t.nameMinLength)
    .matches(/^[a-zA-Z\s\u0600-\u06FF]+$/, t.nameInvalidChars)  // Arabic letters (Unicode range: \u0600-\u06FF)
    .required(t.nameRequired),
  
    description: descriptionRequiredFlag 
    ? Yup.string() .required(t.descriptionRequired ) // Add validation for description
    .min(10, t.descriptionMinLength )
    : Yup.string(), 

    // Conditionally validate ID number based on idNumberFlag
    idNumber: idNumberFlag
    ? Yup.string()
        .matches(/^\d+$/, t.idNumberInvalid) // Ensure the ID is numeric
        .min(6, t.idNumberMinLength) // Ensure the ID has at least 6 digits
        .max(20, t.idNumberMaxLength) // Ensure the ID has no more than 20 digits
        .required(t.idNumberRequired) // Make the ID field required
    : Yup.string(), // If idNumberFlag is false, don't validate the ID
  // If flag is false, the field is not validated

    // email: Yup.string()
    // .email(t.invalidEmail)  // Validates email format
    // .test('is-valid-email', t.emailTest , (value) => {
    //   // Custom check to ensure a valid email format is used
    //   return value && /@/.test(value) && /\./.test(value);
    // }),

    address: addressRequiredFlag 
        ? Yup.string()
            .required(t.addressRequired )
            .min(5, t.addressMinLength )
            .test('not-all-numbers', t.addressInvalid , (value) => {
                // Custom check to ensure the address doesn't consist of only numbers
                return value && !/^\d+$/.test(value);
            })
        : Yup.string() 
});
export const signInValidationSchema = (t = {}) => Yup.object().shape({
    phone: Yup.string()
      .required(t.phoneRequired),
    //   .matches(/^\+\d{10,15}$/, t.phoneInvalid),
    password: Yup.string()
        .required(t.passwordRequired || "Password is required")
//         .min(8, t.passwordMinLength || "Password must be at least 8 characters")
//         .matches(/[A-Z]/, t.passwordUppercase || "Password must contain at least one uppercase letter")
//         .matches(/[a-z]/, t.passwordLowercase || "Password must contain at least one lowercase letter")
//         .matches(/[0-9]/, t.passwordNumber || "Password must contain at least one number")
//         .matches(/[!@#$%^&*(),.?":{}|<>]/, t.passwordSpecial || "Password must contain at least one special character"),
});
export const step2ValidationSchema = (t) => Yup.object().shape({
    city: Yup.string().required(t.cityRequired),
    district: Yup.string()
        .required(t.districtRequired)
        .test("city-selected",t.citySelected, function (value) {
            return !!this.parent.city;
        }),
    project: Yup.string()
        .required(t.projectRequired)
        .test("district-selected", t.districtSelected, function (value) {
            return !!this.parent.district;
        }),
    building: Yup.string()
        .required(t.buildingRequired)
        .test("project-selected",t.projectSelected, function (value) {
            return !!this.parent.project;
        }),
    floor: Yup.string()
        .required(t.floorRequired)
        .test("building-selected", t.buildingSelected, function (value) {
            return !!this.parent.building;
        }),
    unit: Yup.string()
        // .required("Unit is required")
        .test("floor-selected", t.floorSelected, function (value) {
            return !!this.parent.floor;
        }),
        
});
export const unitFormValidationSchema = (t) =>
    Yup.object().shape({
        unitNameEnglish: Yup.string()
            .required(t.unitNameEnglishRequired) // Required message
            .min(4, t.unitNameEnglishMinLength) // Minimum length
            .matches(
                /^[A-Za-z0-9\s]+$/,
                t.unitNameEnglishInvalid
            ), // English letters only
        unitNameArabic: Yup.string()
            .required(t.unitNameArabicRequired) 
            .min(4, t.unitNameArabicMinLength) 
            .matches(
                /^[\u0621-\u064A0-9\s]+$/,
                t.unitNameArabicInvalid
            ), // Arabic letters only
        descriptionEnglish: Yup.string()
            .required(t.descriptionEnglishRequired) 
            .min(5, t.descriptionEnglishMinLength) 
            .matches(
                /^[A-Za-z0-9\s]+$/,
                t.descriptionEnglishInvalid
            ), // English letters only
        descriptionArabic: Yup.string()
            .required(t.descriptionArabicRequired) // Required message
            .min(5, t.descriptionArabicMinLength)
            .matches(
                /^[\u0621-\u064A0-9\s]+$/,
                t.descriptionArabicInvalid ), // Arabic letters only
    });


export const requestFormValidationSchema=(t ) => Yup.object().shape({
    mainRequestType: Yup.string()
        .required("Main request type is required"), // Ensure main type is selected first
    subRequestType: Yup.string()
        .required("Sub request type is required")
        .test("mainRequestType-selected", "Please select a main request type first", function (value) {
            return !!this.parent.mainRequestType; // Ensure mainRequestType is selected first
        }),
        RequestName: Yup.string()
        .required("Request Name is required")
        .test("subRequestType-selected", "Please select a sub request type first", function (value) {
            return !!this.parent.subRequestType; // Ensure subRequestType is selected first
        }),
    city: Yup.string().required("City is required"),
    district: Yup.string()
        .required("District is required")
        .test("city-selected", "Please select a city first", function (value) {
            return !!this.parent.city;
        }),
    project: Yup.string()
        .required("Project is required")
        .test("district-selected", "Please select a district first", function (value) {
            return !!this.parent.district;
        }),
    building: Yup.string()
        .required("Building is required")
        .test("project-selected", "Please select a project first", function (value) {
            return !!this.parent.project;
        }),
    floor: Yup.string()
        .required("Floor is required")
        .test("building-selected", "Please select a building first", function (value) {
            return !!this.parent.building;
        }),
    unit: Yup.string()
        .required("Unit is required")
        .test("floor-selected", "Please select a floor first", function (value) {
            return !!this.parent.floor;
        }),
    priority: Yup.string()
    .required("Priority is required")  , 
    description: Yup.string()
    .required(t.descriptionRequired || "Description is required") // Add validation for description
    .min(10, t.descriptionMinLength || "Description must be at least 10 characters long")
});
